export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7686.787e45c0.jpg";